import React from "react";
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Slide from 'react-reveal/Slide';

import { SectionTitle } from 'component/reuse/title';
import { ShowLanding } from 'component/reuse/show';


const ABOUT = [
  {'type': 'text', 'content': "We all want to make sure our product / service offerings are clearly <strong>communicated</strong> to our potential customers."},
  {'type': 'text', 'content': "But let's face it, we have to get it done <strong>quickly</strong>. Customers, when evaluating solutions might not spend too much time on one product and keeping their attention for long is really hard."},
  {'type': 'text', 'content': "Companies use all channels possible to make sure they grab and keep user attention. They have great looking landing pages, they make sure to get user contacts and keep pinging them about updates or asking for feedback on why they didn't get picked."},
  {'type': 'text', 'content': "These efforts might not even yield the desired results. Furthermore, failed efforts can be painfully frustrating, totally demoralizing and cripplingly expensive."},
  {'type': 'text', 'content': "At <strong>DivShow</strong>, we know there's <strong>a better way</strong> through the means of a new medium"},
  {'type': 'text', 'content': "At DivShow, we're building a platform for product owners to build presentations (we call them shows) for their websites and share with consumers with little to no effort. This allows for clearer vision delivery with less time spent by customer consuming the information."},
  {'type': 'text', 'content': "Right now we're building the future of user communication tools .. And we're <strong>just getting started!</strong>"},
]


function AboutComponentItem(props){
  var aboutItem = props.items;

  if (aboutItem.type === "text"){
    return (<div   style={{textAlign: 'justify', textJustify: 'inter-word'}} className="family-code mx-3 my-3 text-wide-2" dangerouslySetInnerHTML={{__html: aboutItem.content }}></div>)
  }

  if (aboutItem.type === "list"){
    var rows = [];
    aboutItem.content.forEach(function(listItem, i){
      rows.push(<li key={'about_list_item_'+i} ><div className="" dangerouslySetInnerHTML={{__html: listItem }}></div></li>);
    });

    return (
        <div>
          <div className="" dangerouslySetInnerHTML={{__html: aboutItem.title }}></div>
          <ul className="">
            {rows}
          </ul>
        </div>
    )
  }

  return (<div> SOMETHING WENT WRONG !</div>)
}


export default function AboutComponent(props) {
    const about = ABOUT;

    return (
      <div className="">
        <div className="slant slant-top-right-secondary-1"></div>
        <section id="about" className="content-section highlight-secondary-1">
          <div className="">
          <SectionTitle first="DivShow explained" second="" flip={true}/>
            <div className="container-fluid text-black-4">

              <div className="row">
                <div className="col-sm-7">
                <Slide left>
                  <div className="family-p mx-4 my-4 text-wide-2">
                    <p className="text-black">If you don't wish to read the following wall of text ...</p>
                    <div className=""><ShowLanding show_xid={'ijhsfsqgh'} type="small" text={"Play me a show instead!"} /></div>
                  </div>

                  <div className="text-muted">
                  {about.map(function(aboutItem, i){
                    return (<AboutComponentItem items={aboutItem} key={'about_item_' + i}/>)
                  })}
                  </div>
                </Slide>
                </div>

                <div className="col-sm-5 flex-center">
                <Slide right>
                  <div className="d-none d-lg-block">
                    <div className="img img-fluid  animated slideInRight">
                      <img className="hero lazyload" data-src="/static/images/about.svg" alt="A new kind of presentation tool that helps you get your product offering across through on site presentations." />
                    </div> 
                  </div>
                </Slide>
                </div>

              </div>
              
            </div>
          </div>
        </section>
        <div className="slant slant-bottom-left-secondary-1"></div>
      </div>
    )
}